<template>
  <v-container fluid py-0>
    <v-layout wrap row>
      <template v-if="!loading">
        <v-flex v-if="video && video.src" xs12 md6>
          <youtube-player
            v-if="video.type == 'video/youtube'"
            ref="youtubePlayer"
            :video="video"
          />

          <video-player v-else ref="videoPlayer" :video="video" />
        </v-flex>
      </template>
      <v-flex xs12 md6 :offset-md3="!video || !video.src">
        <EventList
          :items="formatedList"
          :loading="loading || loadingEvents"
          @create="setNew"
          @setEvent="setEvent"
        />
      </v-flex>
    </v-layout>

    <dialog-event
      :dialog.sync="dialog"
      :match-id="matchId"
      :training-id="trainingId"
      :home-team-id="homeTeamId"
      :visitor-team-id="visitorTeamId"
      :location="location"
    />
    <!-- <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    /> -->
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import EventList from './match-events/components/EventList'
import DialogEvent from '@/components/widgets/dialog/DialogEvent'
// import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import VideoPlayer from '@/components/widgets/video/VideoPlayer'
import YoutubePlayer from '@/components/widgets/video/YoutubePlayer'

export default {
  components: {
    VideoPlayer,
    YoutubePlayer,
    // DialogDelete,
    DialogEvent,
    EventList,
  },
  props: {
    matchId: {
      type: String,
      default: '',
      required: false,
    },
    trainingId: {
      type: String,
      default: '',
      required: false,
    },
    homeTeamId: {
      type: String,
      default: '',
      required: false,
    },
    visitorTeamId: {
      type: String,
      default: '',
      required: false,
    },
    location: {
      type: String,
      default: '',
      required: false,
    },
    video: {
      type: Object,
      required: false,
      default: () => {},
    },
    typeView: {
      type: String,
      default: 'form',
    },
  },
  data() {
    return {
      localEvent: {},
      eventId: '',
      duration: 0,
      dialog: false,
      idDelete: false,
      dialogDelete: false,
      loadingEvents: false,
    }
  },

  computed: {
    ...mapState({
      loading: (state) => state.matchEvents.loading,
      selected: (state) => state.matchEvents.selected,
    }),
    ...mapGetters({
      formatedList: 'matchEvents/formatedList',
    }),

    time() {
      return (this.localEvent.minute || 0) * 60 + (this.localEvent.second || 0)
    },
    maxMinute() {
      return 59
      // return Math.floor(this.duration / 60)
    },
    maxSecond() {
      return 59
      // if (this.localEvent.minute == this.maxMinute) { return Math.floor(this.duration % 60) } else return 59
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'matchEvents/fetchOne',
      fetchMatchEvents: 'matches/fetchEvents',
      fetchTrainingEvents: 'trainings/fetchEvents',
      setDelete: 'matchEvents/delete',
      fetchTypeEvents: 'typeEvents/fetchList',
    }),
    setEvent(event) {
      // if (this.typeView === 'form') this.setOne(event._id)
      // else if (this.typeView === 'view')
      this.setTime(event.fromVideoStart)
    },
    setTime(time) {
      if (this.$refs.videoPlayer) this.$refs.videoPlayer.setTime(time)
    },
    setNew() {
      this.loadingEvents = true
      let promise = new Promise((resolve) => resolve())
      if (this.trainingId) {
        promise = this.fetchTrainingEvents(this.trainingId)
      } else if (this.matchId) {
        promise = this.fetchMatchEvents(this.matchId)
      }
      promise
        .then(() => {
          this.dialog = true
        })
        .finally(() => {
          this.loadingEvents = false
        })
    },
    setOne(id) {
      this.fetchOne(id).then(() => {
        this.$nextTick(() => {
          this.dialog = true
        })
      })
    },
    updateTime(time) {
      this.duration = time
    },
  },
}
</script>
